import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Input } from "../components/ui/input";
import { Switch } from "../components/ui/switch";
import { Button } from "../components/ui/button";
import { Textarea } from "../components/ui/textarea";

function Row({ c, onSaved }) {
  const [f, setF] = useState(c);
  const [open, setOpen] = useState(false);
  const dirty = ["name", "order", "image", "heading", "intro", "description"].some((k) => (f[k] ?? "") !== (c[k] ?? ""));
  const save = async (data) => {
    try {
      const r = await api.patch(`/admin/categories/${c.slug}`, data);
      onSaved(r.data);
      toast.success("Categoria salvata");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <>
    <tr className="border-b border-white/5" data-testid={`admin-cat-row-${c.slug}`}>
      <td className="p-3"><img src={f.image} alt="" className="w-14 h-10 object-cover rounded" /></td>
      <td className="p-3"><Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="bg-white/5 text-white border-white/15 min-w-[140px]" data-testid={`admin-cat-name-${c.slug}`} /></td>
      <td className="p-3 hidden lg:table-cell"><Input value={f.image} onChange={(e) => setF({ ...f, image: e.target.value })} className="bg-white/5 text-white border-white/15" /></td>
      <td className="p-3"><Input type="number" value={f.order} onChange={(e) => setF({ ...f, order: Number(e.target.value) })} className="bg-white/5 text-white border-white/15 w-20" /></td>
      <td className="p-3 text-center">{c.total?.toLocaleString("it-IT")}</td>
      <td className="p-3 text-center"><Switch checked={!!c.show_home} onCheckedChange={(v) => save({ show_home: v })} data-testid={`admin-cat-home-${c.slug}`} /></td>
      <td className="p-3"><div className="flex gap-1">
        <Button size="sm" variant="ghost" onClick={() => setOpen(!open)} className="text-slate-200 hover:bg-white/10 hover:text-white" data-testid={`admin-cat-texts-${c.slug}`}>Testi SEO</Button>
        {dirty && <Button size="sm" onClick={() => save({ name: f.name, order: f.order, image: f.image, heading: f.heading || "", intro: f.intro || "", description: f.description || "" })} className="bg-[#fc0] text-[#043856] hover:bg-yellow-300" data-testid={`admin-cat-save-${c.slug}`}>Salva</Button>}
      </div></td>
    </tr>
    {open && (
      <tr className="border-b border-white/5 bg-white/[0.03]">
        <td colSpan={7} className="p-4 space-y-3">
          <Input value={f.heading || ""} onChange={(e) => setF({ ...f, heading: e.target.value })} placeholder="Titolo H1 (es. Giochi di Corse)" className="bg-white/5 text-white border-white/15" data-testid={`admin-cat-heading-${c.slug}`} />
          <Input value={f.intro || ""} onChange={(e) => setF({ ...f, intro: e.target.value })} placeholder="Frase introduttiva (anche meta description)" className="bg-white/5 text-white border-white/15" />
          <Textarea rows={7} value={f.description || ""} onChange={(e) => setF({ ...f, description: e.target.value })} placeholder="Testo della categoria (paragrafi separati da una riga vuota)" className="bg-white/5 text-white border-white/15" data-testid={`admin-cat-description-${c.slug}`} />
        </td>
      </tr>
    )}
    </>
  );
}

export default function AdminCategories() {
  const [list, setList] = useState([]);
  useEffect(() => {
    api.get("/categories").then((r) => setList(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, []);
  const onSaved = (c) => setList((l) => l.map((x) => (x.slug === c.slug ? c : x)).sort((a, b) => a.order - b.order));
  return (
    <div className="space-y-6" data-testid="admin-categories">
      <h1 className="text-3xl font-bold text-white" style={{ fontFamily: "Oswald" }}>Categorie</h1>
      <p className="text-sm text-slate-300">"In home" mostra la categoria nei link rapidi della home page. L'ordine determina la posizione nei menu.</p>
      <div className="rounded-xl border border-white/10 bg-[#0d2233] overflow-x-auto">
        <table className="w-full text-sm text-slate-200">
          <thead className="text-xs uppercase text-slate-300 border-b border-white/10">
            <tr><th className="p-3" /><th className="p-3 text-left">Nome</th><th className="p-3 text-left hidden lg:table-cell">Immagine</th><th className="p-3 text-left">Ordine</th><th className="p-3">Giochi</th><th className="p-3">In home</th><th className="p-3" /></tr>
          </thead>
          <tbody>{list.map((c) => <Row key={`${c.slug}-${c.name}-${c.order}-${c.show_home}-${(c.description || "").length}-${c.heading}`} c={c} onSaved={onSaved} />)}</tbody>
        </table>
      </div>
    </div>
  );
}
